<script setup lang="ts">
import benefitIcon from '@/assets/components/benefitsComponent/icon_benefit-min.png'
import benefitIconPlaceHolder from '@/assets/components/benefitsComponent/icon_benefit-small-min.png'
import { goatBenefits } from '@/components/layout/LoginDialog/LoginDialog'

interface Props {
  modalMode?: boolean
}

defineProps<Props>()
const { t } = useI18n()
</script>

<template>
  <div
    class="mx-auto text-center max-w-2xl big:max-w-(--breakpoint-screen-xl) text-white tracking-wider"
    :class="{ 'big:px-16 mt-5 big:mt-10 big:mb-14': !modalMode, '-mt-4': modalMode }"
  >
    <div
      class="bg-gs-bg bg-linear-to-b from-gs-bg-gradient-from to-gs-bg-gradient-to  rounded-2xl flex flex-col items-center pt-10 big:pt-14 pb-14 big:pb-16 px-2 big:px-16"
      :class="{ 'big:mt-10 mx-3': !modalMode }"
    >
      <h1 class="uppercase text-lg big:text-2xl font-semibold tracking-wide big:tracking-widest mb-6 big:mb-8">
        {{ t('goatBenefits.title') }}
      </h1>
      <div class="flex flex-col gap-3 w-full">
        <div
          v-for="(benefit, index) in goatBenefits"
          :key="index"
          class="flex flex-row justify-start gap-x-2 big:gap-x-3 w-full"
        >
          <div>
            <el-image
              :src="benefitIcon"
              lazy
              :alt="t('goatBtn.benefitIconAlt')"
              class="w-8 big:w-9"
            >
              <template #placeholder>
                <img
                  :src="benefitIconPlaceHolder"
                  :alt="t('goatBtn.benefitIconAlt')"
                  class="w-8 big:w-9"
                >
              </template>
            </el-image>
          </div>
          <div class="grow pt-1.5 text-left text-base big:text-lg">
            <h2 class="font-semibold leading-tight">
              {{ benefit.header }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">

</style>
